import React from "react";
import PropTypes from 'prop-types';
// Material-UI
import ListItemText from "@material-ui/core/ListItemText";
import { DataGrid, esES } from '@material-ui/data-grid';
// Context
import { useUsuarios } from "./UsuariosContext";

function renderDual(params) {
  if (!params.value) return null;
  const [first = '', second = ''] = params.value.split(', ');
  return <ListItemText primary={first} secondary={second} />;
}

const tableColumns = [
  { field: 'identity', headerName: 'Nombre y Usuario', renderCell: renderDual, flex: 1 },
  { field: 'contact', headerName: 'Contacto', renderCell: renderDual, flex: 1 },
  { field: 'strRoles', headerName: 'Roles', flex: 1 },
  { field: 'enabled', headerName: 'Habilitado', flex: 0.7, type: 'boolean', width: 120 },
];

export default function TablaUsuarios({ rows }) {
  const { setIsEdit, setIsDel, getTheUser,
    selectionModel, setSelectionModel } = useUsuarios();

  return (
    <DataGrid
      disableColumnFilter
      disableDensitySelector
      checkboxSelection
      columns={tableColumns}
      localeText={esES.props.MuiDataGrid.localeText}
      rows={rows}
      onSelectionModelChange={(newSelectionModel) => {
        setIsDel(newSelectionModel.length > 0);
        setIsEdit(newSelectionModel.length === 1);
        if (newSelectionModel.length === 1) getTheUser(newSelectionModel[0]);
        setSelectionModel(newSelectionModel);
      }}
      selectionModel={selectionModel}
      hideFooterSelectedRowCount
    />
  );
}

TablaUsuarios.propTypes = {
  rows: PropTypes.array.isRequired,
};
